module.exports = __webpack_public_path__ + "img/1480852299.ea4baa8b.jpg";